<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="true"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      :createLog="true"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      staticFilters: [],
      dateFilter: [],
      filters: [],
      params: {},
      val: [],
      modalCreate: "business",
      fields: [
        {
          label: "Номер телефона покупателя",
          key: "phone",
          labelKey: "client_phone",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
        {
          label: "Имя покупателя",
          key: "first_name",
          labelKey: "client_first_name",
          type: "field",
        },
        {
          label: "Фамилия покупателя",
          key: "last_name",
          labelKey: "client_last_name",
          type: "field",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_order",
      itemLink: "orders",
      setLink: "orders",
      columns: [
        {
          detail: true,

          // remove: true,
        },
        {
          key: "id",
          titleKey: "id",
          title: "Номер",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          title: "Фин. партнеры",
          key: "transactions",
          titleKey: "fin_partners",
          object: "state",
          disableLink: true,
        },
        {
          key: "client",
          titleKey: "client",
          object: "phone",
          title: "Клиент",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          full: true,
          key: "status",
          titleKey: "status_order",
          object: "name",
          title: "Статус заказа",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          full: true,
          key: "shop",
          titleKey: "shop",
          object: "name",
          title: "Магазин",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price_total",
          titleKey: "price_total",
          price: true,
          title: "Цена заказа",
        },
        {
          disableLink: true,
          key: "discounts",
          titleKey: "sale",
          object: "promotion_name",
          title: "Акция",
        },
        {
          key: "created_at",
          titleKey: "created_at",
          title: "Создан",
          dateTimeFormat: true,
          full: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
